import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Checkbox } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { VendorProfile as VendorProfileAction } from "../../../Redux/action/VendorProfileAction";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import { useNavigate, useParams } from "react-router-dom";
import ImportantNotes from "../../Common/ImportantNotes";
import { SpinLoader } from "../ImportCandidates";
import Swal from "sweetalert2";
import axios from "axios";
import {
  fetchDepartmentDetails,
  fetchDesignationDetails,
} from "../../../Redux/action/MasterSkillAction";
import {
  getCandidateById,
  UpdateTeamMember,
} from "../../../Services/candidateServies";
import BackButton from "../../Common/BackButton/BackButton";

const UpdateTeam = () => {
  const baseUrl = process.env.REACT_APP_API_PATH;
  const { id } = useParams();
  const [dialCode, setDialCode] = useState("91");
  const [countryIso, setCountryIso] = useState("in"); // e.g., "in"
  const [loading, setLoading] = useState(false);
  const AllDeparmentList = useSelector(
    (state) => state?.MasterTableDetails?.department?.content
  );
  const AllDesignationList = useSelector(
    (state) => state?.MasterTableDetails?.designation?.content
  );
  const dispatch = useDispatch();
  const [isBillable, setIsBillable] = useState(true);
  const [state, setState] = useState({
    candidateId: "",
    firstName: "",
    lastName: "",
    email: "",
    userType: "CANDIDATE",
    currentDesignation: "",
    reportingManager: "",
    panCardNumber: "",
    aadharCardNumber: "",
    aadharCardNumber2: "",
    validity: "",
    mobile: "",
    availableForWork: false,
  });
  const [countryCode, setCountryCode] = useState("in"); // Default country code
  const [department, setDepartment] = useState("");
  const [value, setValue] = useState();
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    getCandidateById(id).then((res) => {
      const data = res?.data;
      if (!data) return;
      setState((prev) => ({
        ...prev,
        candidateId: data?.candidateId,
        firstName: data?.firstName,
        lastName: data?.lastName,
        email: data?.email,
        userType: "CANDIDATE",
        currentDesignation: data?.currentDesignation,
        reportingManager: data?.reportingManager,
        panCardNumber: data?.panCardNumber,
        aadharCardNumber: data?.aadharCardNumber,
        aadharCardNumber2: data?.aadharCardNumber,
        validity: data?.validity,
        mobile: data?.mobile || "",
        countryCode: data?.countryCode || "in",
        availableForWork: data?.availableForWork || false,
      }));

      setDialCode(data?.dialCode || "91");
      setCountryIso(data?.countryCode?.toLowerCase() || "in");
      setIsBillable(data?.isBillable || false);
      setDepartment(data?.department || "");
    });
  }, [id]);

  const handleAccept = (data) => {
    // Create a style element
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
          .custom-confirm-button {
              background-color: #286a94 !important;
              color: white;
              border-bottom: 1px solid rgb(57, 57, 57);
          }
          .custom-title {
              border-bottom: 0.5px solid #adadad;
              color: #286a94 !important;
              padding-bottom: 10px;
          }
              .msg-paragraph {
              margin-top:10px;
          }
        `;
    // Append the style to the head of the document
    document.getElementsByTagName("head")[0].appendChild(style);

    const para = document.createElement("div");
    para.className = "custom-paragraph";
    para.innerText = "Are you sure you want to send request?";

    const msgPara = document.createElement("div");
    msgPara.className = "msg-paragraph";
    msgPara.innerText =
      "The candidate you are trying to add, already has an individual account on EBench";

    const container = document.createElement("div");
    container.appendChild(para);
    container.appendChild(msgPara);
    Swal.fire({
      title: "Send Invitation",
      html: container.outerHTML,
      showCancelButton: true,
      confirmButtonText: "Send",
      customClass: {
        title: "custom-title",
        confirmButton: "custom-confirm-button",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            `${baseUrl}/ebench/send_request`,
            data
          );
          // toast.info('Your personal account has been deactivated, try logging in with your professional account', { autoClose: 10000 });
          console.log("API Response:", response.data);
          toast.success("Invitation sent successfully");

          setTimeout(() => {
            navigate("/team-list");
          }, 2000);
        } catch (error) {
          console.error("Error accepting:", error);
          Swal.fire(
            "Error",
            "There was an error sending the invitation",
            "error"
          );
        }
      }
    });
  };
  const { userResult } = useSelector((state) => state.Auth);
  let vendorId = userResult?.vendorid;

  const {
    firstName,
    lastName,
    email,
    currentDesignation,
    candidateId,
    reportingManager,
    validity,
    mobile,
    panCardNumber,
    aadharCardNumber,
    aadharCardNumber2,
    availableForWork,
  } = state;

  const content = {
    candidateId,
    vendorId,
    firstName,
    lastName,
    email,
    currentDesignation,
    reportingManager,
    // validity,
    isBillable,
    mobile,
    panCardNumber,
    aadharCardNumber,
    department,
    countryCode: countryIso,
    dialCode,
    availableForWork,
  };

  useEffect(() => {
    dispatch(fetchDepartmentDetails());
    dispatch(fetchDesignationDetails());
    dispatch(VendorProfileAction());
    window.scrollTo(0, 0);
  }, []);

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    const updatedValue = type === "checkbox" ? checked : value;
    if (name === "panCardNumber") {
      const uppercasedValue = updatedValue.toUpperCase();
      setState({ ...state, [name]: uppercasedValue });
    } else {
      setState({ ...state, [name]: updatedValue });
    }
  };
  const validatePan = (pan) => {
    const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return panPattern.test(pan);
  };
  const handleDropdownChange = (e) => {
    setDepartment(e.target.value);
  };
  const handleCopy = (e) => {
    e.preventDefault();
  };
  const isIndian = dialCode === "91";

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isIndianNumber = dialCode === "91" && /^[6-9]\d{9}$/.test(mobile);
    const isInternationalNumber =
      dialCode !== "91" && /^\d{7,15}$/.test(mobile);

    if (!mobile) {
      toast.error("Please enter your phone number");
      return;
    }

    if (!isIndianNumber && !isInternationalNumber) {
      toast.error(
        dialCode === "91"
          ? "Please enter a valid 10-digit Indian mobile number"
          : "Please enter a valid international phone number (7–15 digits)"
      );
      return;
    }

    if (isIndian && !validatePan(panCardNumber)) {
      toast.error("Invalid PAN card number. Format: XXXXX9999X");
      return;
    }

    //  Aadhaar / Government ID Validation
    if (isIndian) {
      if (aadharCardNumber.length !== 12 || aadharCardNumber2.length !== 12) {
        toast.error("Aadhaar Number must be 12 digits");
        return;
      }
    }

    if (aadharCardNumber !== aadharCardNumber2) {
      toast.error(
        `${isIndian ? "Aadhaar" : "Government ID"} numbers do not match`
      );
      return;
    }

    try {
      setLoading(true);
      const res = await UpdateTeamMember({
        ...content,
      });

      if (res?.data?.status?.httpCode === "200") {
        toast.success("Team Member updated successfully");
        navigate(-1);
      } else {
        toast.error("Update failed. Please try again.");
      }
    } catch (error) {
      console.error("Error updating:", error);
      toast.error("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isBillable) {
      setState({ ...state, availableForWork: false });
    }
  }, [isBillable]);
  return (
    <div>
      <ToastContainer />
      <div
        className="d-flex flex-column flex-md-row gap-4 container mt-4"
        style={{ paddingBottom: "10px" }}
      >
        {/* <TableHeader isSearch={false} isFilter={false} heading={'Add Team Member'} /> */}
        <div className="common_wrapper mt-0">
          <BackButton />
          <div className="can_prof_container">
            <div className="">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="">
                  <div className="card can_prof_main">
                    <div className="card-header prof_header d-flex justify-content-between">
                      Update Team Member
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="col-12 col-lg-6">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="isbillable"
                              id="billable"
                              value="true"
                              checked={isBillable === true}
                              onChange={() => setIsBillable(true)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="billable"
                            >
                              Billable
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="isbillable"
                              id="non-billable"
                              value="false"
                              checked={isBillable === false}
                              onChange={() => setIsBillable(false)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="non-billable"
                            >
                              Non-Billable
                            </label>
                          </div>
                        </div>
                        <div className="row gx-3 mb-3">
                          <div className="col-12 col-lg-6">
                            <label className="small mb-1" htmlFor="inputCity">
                              First Name
                              <span
                                style={{ color: "red", paddingLeft: 4 }}
                                className="text-red-700 pl-[2px]"
                              >
                                *
                              </span>
                            </label>
                            <input
                              className="form-control"
                              id="inputCity"
                              type="text"
                              placeholder="Enter your first name"
                              name="firstName"
                              value={firstName}
                              required
                              onChange={handleInputChange}
                              pattern="^[A-Za-z]+$"
                              title="Only alphabetic characters are allowed"
                              minLength={2}
                              maxLength={50}
                              // disabled={isDisabled}
                            />
                            {errors.firstName && (
                              <div
                                style={{
                                  color: "red",
                                  margin: "5px 0 0 0",
                                  textAlign: "left",
                                  fontSize: "14px",
                                }}
                              >
                                {errors.firstName}
                              </div>
                            )}
                          </div>

                          <div className="col-12 col-lg-6">
                            <label
                              className="small mb-1"
                              htmlFor="inputCountry"
                            >
                              Last Name
                              <span
                                style={{ color: "red", paddingLeft: 4 }}
                                className="text-red-700 pl-[2px]"
                              >
                                *
                              </span>
                            </label>
                            <input
                              className="form-control"
                              id="inputCountry"
                              type="text"
                              placeholder="Enter your last name"
                              name="lastName"
                              required
                              value={lastName}
                              onChange={handleInputChange}
                              pattern="^[A-Za-z]+$"
                              title="Only alphabetic characters are allowed"
                              minLength={2}
                              maxLength={50}
                            />
                            {errors.lastName && (
                              <div
                                style={{
                                  color: "red",
                                  margin: "5px 0 0 0",
                                  textAlign: "left",
                                  fontSize: "14px",
                                }}
                              >
                                {errors.lastName}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row gx-3 mb-3">
                          <div className="col-12 col-lg-6">
                            <label className="small mb-1" htmlFor="inputGender">
                              Email
                              <span
                                style={{ color: "red", paddingLeft: 4 }}
                                className="text-red-700 pl-[2px]"
                              >
                                *
                              </span>
                            </label>
                            <input
                              className="form-control"
                              id="inputGender"
                              type="email"
                              placeholder="Enter your email"
                              name="email"
                              value={email}
                              onChange={handleInputChange}
                              maxLength="254"
                              required
                            />
                          </div>
                          <div className="col-12 col-lg-6">
                            <label
                              className="small mb-1"
                              htmlFor="inputHobbies"
                            >
                              {isIndian ? "PAN Number" : "Government Tax ID"}
                              <span
                                style={{ color: "red", paddingLeft: 4 }}
                                className="text-red-700 pl-[2px]"
                              >
                                *
                              </span>
                            </label>
                            <input
                              className="form-control"
                              id="inputHobbies"
                              type="text"
                              placeholder={`Enter your ${
                                isIndian ? "PAN Number" : "Government Tax ID"
                              }`}
                              name="panCardNumber"
                              required
                              value={panCardNumber}
                              onChange={handleInputChange}
                              inputProps={{
                                maxLength: 10,
                              }}
                              maxLength={isIndian ? 10 : ""}
                            />
                          </div>
                        </div>
                        <div className="row gx-3 mb-3">
                          <div className="col-12 col-lg-6">
                            <label
                              className="small mb-1"
                              htmlFor="inputInterest"
                            >
                              Current Designation
                              <span
                                style={{ color: "red", paddingLeft: 4 }}
                                className="text-red-700 pl-[2px]"
                              >
                                *
                              </span>
                            </label>

                            <select
                              id="inputInterest"
                              value={currentDesignation}
                              required
                              name="currentDesignation"
                              onChange={handleInputChange}
                              className="form-select"
                            >
                              <option value="" disabled hidden>
                                Select any designation
                              </option>
                              {AllDesignationList?.map((option) => (
                                <option
                                  key={option?.designationId}
                                  value={option?.designation}
                                >
                                  {option.designation}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-12 col-lg-6">
                            <label className="small mb-1" htmlFor="Aadhaar">
                              {isIndian ? "Adhaar Number" : "Government ID"}
                              <span
                                style={{ color: "red", paddingLeft: 4 }}
                                className="text-red-700 pl-[2px]"
                              >
                                *
                              </span>
                            </label>
                            <input
                              className="form-control"
                              id="Aadhaar"
                              type={"text"}
                              required
                              placeholder={`Enter your ${
                                isIndian ? "adhaar number" : "government id"
                              }`}
                              name="aadharCardNumber"
                              value={aadharCardNumber}
                              maxLength={12}
                              minLength={12}
                              onChange={(e) => {
                                const numericValue = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                                handleInputChange({
                                  target: {
                                    name: "aadharCardNumber",
                                    value: numericValue,
                                  },
                                });
                              }}
                              onCopy={handleCopy}
                              onFocus={(e) =>
                                e.target.removeAttribute("readOnly")
                              }
                            />
                          </div>
                        </div>
                        <div className="row gx-3 mb-3">
                          <div className="col-12 col-lg-6">
                            <label className="small mb-1" htmlFor="Reporting">
                              Reporting Manager
                            </label>
                            <input
                              className="form-control"
                              id="Reporting"
                              type="text"
                              placeholder="Enter your reporting manager"
                              name="reportingManager"
                              value={reportingManager}
                              onChange={handleInputChange}
                              pattern="^[A-Za-z]+(?: [A-Za-z]+)*$"
                              title="Only alphabetic characters are allowed"
                              minLength={2}
                              maxLength={50}
                            />
                          </div>

                          <div className="col-12 col-lg-6">
                            <label className="small mb-1" htmlFor="Aadhaar2">
                              Confirm{" "}
                              {isIndian ? "Adhaar Number" : "Government ID"}
                              <span
                                style={{ color: "red", paddingLeft: 4 }}
                                className="text-red-700 pl-[2px]"
                              >
                                *
                              </span>
                            </label>
                            <input
                              className="form-control"
                              id="Aadhaar2"
                              type={isIndian ? "number" : "text"}
                              required
                              placeholder={`Confirm your ${
                                isIndian ? "adhaar number" : "government id"
                              }`}
                              name="aadharCardNumber2"
                              value={aadharCardNumber2}
                              maxLength={12}
                              minLength={12}
                              onChange={(e) => {
                                const numericValue = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                                handleInputChange({
                                  target: {
                                    name: "aadharCardNumber2",
                                    value: numericValue,
                                  },
                                });
                              }}
                            />

                            {errors.aadharCardNumber && (
                              <div
                                style={{
                                  color: "red",
                                  margin: "5px 0 0 0",
                                  textAlign: "left",
                                  fontSize: "14px",
                                }}
                              >
                                {errors.aadharCardNumber}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row gx-3 mb-3">
                          <div className="col-12 col-lg-6">
                            <label className="small mb-1" htmlFor="department">
                              Department
                              <span
                                style={{ color: "red", paddingLeft: 4 }}
                                className="text-red-700 pl-[2px]"
                              >
                                *
                              </span>
                            </label>
                            <select
                              id="department"
                              required
                              value={department}
                              name="department"
                              onChange={handleDropdownChange}
                              className="form-select"
                            >
                              <option value="" disabled hidden>
                                Select any department
                              </option>
                              {AllDeparmentList &&
                                AllDeparmentList?.map((option) => (
                                  <option
                                    key={option?.departmentId}
                                    value={option?.departmentName}
                                  >
                                    {option?.departmentName}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="col-12 col-lg-6">
                            <div>
                              <label className="small mb-1">
                                Mobile{" "}
                                <span style={{ color: "red", paddingLeft: 4 }}>
                                  *
                                </span>
                              </label>

                              <div className="d-flex align-items-center flex-wrap gap-2">
                                {/* Country / Dial Code Selector */}
                                <div>
                                  <PhoneInput
                                    inputClass="vendorProfilePhoneInput w-100"
                                    enableSearch={true}
                                    country={countryIso || "in"}
                                    value={`+${dialCode}`}
                                    onChange={(value, countryData) => {
                                      const newDial =
                                        countryData?.dialCode || "91";
                                      const newIso =
                                        countryData?.countryCode?.toLowerCase() ||
                                        "in";
                                      setDialCode(newDial);
                                      setCountryIso(newIso);
                                    }}
                                    disableDropdown={false}
                                    inputStyle={{
                                      width: "100%",
                                      height: "38px",
                                    }}
                                    containerStyle={{
                                      width: "100%",
                                    }}
                                    buttonClass="custom-flag-btn"
                                    dropdownClass="custom-country-dropdown"
                                  />
                                </div>

                                {/* Local Mobile Input */}
                                <div className="flex-grow-1">
                                  <input
                                    type="number"
                                    style={{ marginBottom: "0" }}
                                    className="form-control"
                                    placeholder="Enter Your Mobile Number"
                                    name="mobile"
                                    value={state.mobile || ""}
                                    onChange={(e) => {
                                      const numericValue = e.target.value
                                        .replace(/\D/g, "")
                                        .slice(0, 15);
                                      setState((prev) => ({
                                        ...prev,
                                        mobile: numericValue,
                                      }));
                                    }}
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {isBillable && (
                            <div className="col-md-12">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={availableForWork}
                                    onChange={handleInputChange}
                                    name="availableForWork"
                                  />
                                }
                                label="Open For Market (Availablity Status)"
                              />
                            </div>
                          )}
                        </div>
                        <button
                          className="can_update_prof_btn add_skill_btn"
                          disabled={loading}
                          type="submit"
                        >
                          {loading ? <SpinLoader /> : "Update Member"}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ImportantNotes />
      </div>
    </div>
  );
};

export default UpdateTeam;
